import { ApiError } from '../errors/api-error.js';

export class DetailedReportProfileService {
    constructor(api) {
        this.api = api;
    }

    async list(params = {}) { return this.#call(() => this.api.getAll(params)); }
    async getById(id) { return this.#call(() => this.api.getById(id)); }
    async create(data) { return this.#call(() => this.api.create(data)); }
    async update(id, data) { return this.#call(() => this.api.update(id, data)); }
    async remove(id, expectedVersion) { return this.#call(() => this.api.delete(id, expectedVersion)); }
    async updateSharing(id, data) { return this.#call(() => this.api.updateSharing(id, data)); }
    async setDefault(id, expectedVersion) { return this.#call(() => this.api.setDefault(id, expectedVersion)); }
    async uploadLogo(id, file, expectedVersion) { return this.#call(() => this.api.uploadLogo(id, file, expectedVersion)); }
    async removeLogo(id, expectedVersion) { return this.#call(() => this.api.removeLogo(id, expectedVersion)); }

    async #call(operation) {
        try {
            const response = await operation();
            return {
                success: response.success ?? true,
                data: response.data ?? response,
                message: response.message,
            };
        } catch (error) {
            throw error instanceof ApiError ? error : new ApiError(error.message || 'Detailed report profile request failed');
        }
    }
}
